import { useState } from 'react'
import { initDupPhoneValidator, initValidPhoneValidator } from 'helpers/parsley'
import PhoneWithCountries from 'react-phone-input-2'
import 'styles/vendors/react-phone-input-bootstrap.less'

const Phone = ({
    value,
    name = 'phone',
    country = 'us',
    containerClassName,
    id = name,
    updateMethod,
    label = 'Phone',
    help = 'Use country picker to change country code',
    className: fieldClassName = '',
    checkDup,
    require_phone,
    required = true,
    disableDropdown = false,
    regType,
    ...props
}) => {

    const [initial] = useState(value)

    const onChange = (value, data) => {
        window.$(`#${name}`).parsley().validate();
        updateMethod({ target: { name: name, value: value } })
        updateMethod({ target: { name: name + '_number', value: value.slice(data.dialCode.length) } })
        updateMethod({ target: { name: name + '_prefix', value: data.dialCode } })
        updateMethod({ target: { name: name + '_country', value: data.countryCode } })
    }

    const validator = id.replace('_', '');

    initValidPhoneValidator(validator, initial, required)

    const parsleyObj = {
        'data-parsley-errors-container': `#${id}-parsley-error`,
        [`data-parsley-${validator}`]: validator,
        'data-parsley-trigger': 'input change blur'
    }

    if (checkDup) {
        initDupPhoneValidator(initial, require_phone, regType)
        parsleyObj['data-parsley-dupphone'] = 'dupphone'
    }

    return (
        <div className={`${containerClassName} form-group`}>
            {label !== false ? <label htmlFor={name} className="control-label">{label}</label> : null}
            <PhoneWithCountries
                countryCodeEditable={false}
                country={country}
                specialLabel={false}
                value={value}
                onlyCountries={['us', 'ca']}
                preserveOrder={['onlyCountries']}
                placeholder=""
                jumpCursorToEnd={true}
                onChange={onChange}
                disableDropdown={disableDropdown}
                inputProps={{
                    required,
                    ...props,
                    ...parsleyObj,
                    className: `form-control ${fieldClassName}`,
                    id: id || name,
                }}
            />
            {help && <div className="font-italic text-muted small mt-1">{help}</div>}
            <span id={`${id}-parsley-error`} />
        </div>
    )
}

export default Phone
